<template>
  <v-card
    elevation="10"
    width="100%"
    :loading="isLoading"
  >
    <v-card-title>
      Meus Pacotes
      <v-spacer/>
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="isLoading"
        :loading="isLoading"
        type="table"
        class="mx-auto flex-fill"
        width="100%"
      />
      <v-scale-transition>
        <v-data-table
          v-if="!isLoading"
          :headers="myPackagesHeader"
          :items="packages"
          disable-filtering
          disable-pagination
          disable-sort
          hide-default-footer
        >
          <template v-slot:item.dt_package_due="{ item }">
            <span class="blue--text text--darken-4">{{item.dt_package_due | formatDatetime}}</span>
          </template>
          <template v-slot:item.float_total_hectares="{ item }">
            <span >{{item.float_total_hectares | toFixedWithComma}}</span>
          </template>
        </v-data-table>
      </v-scale-transition>
    </v-card-text>
  </v-card>
</template>

<script>
  import {listUserHectarePackage} from "../../api/api-billing"
  import moment from "moment"

  export default {
    name: "MyPackages",
    data: () => ({
      isLoading: true,

      packages: []
    }),
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      },
      formatDatetime(date) {
        return moment(date).format("DD/MM/YYYY")
      }      
    },
    computed: {
      myPackagesHeader() {
        return [
          {text: "Id", value: "hectare_package.id_type_hectare_package"},
          {text: "Nome do pacote", value: "hectare_package.nm_hectare_package"},
          {text: "Data de vencimento", value: "dt_package_due"},
          {text: "Quantidade (ha)", value: "float_total_hectares"},
        ]
      }
    },
    created() {
      this.isLoading = true

      const listUserHectarePackagePromise = listUserHectarePackage(this.$apiAuth.getAuthToken())
        .then((res) => {              
          const userPackages = res.data.data   
          this.packages = userPackages          
        })

      Promise.all([listUserHectarePackagePromise])
        .finally(() => {
          this.isLoading = false
        })
    }
  }
</script>

<style scoped lang="scss">
</style>
